module.exports = __webpack_public_path__ + "bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica3.jpg?be13c3ddf07c190ce9c6a219943fa759";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggeres_coffee_box_mockup_packaging_design_corrugated_box_arabica3.jpg
// module id = 26
// module chunks = 0